var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navigation'),_c('router-view'),_c('div',[_c('img',{staticClass:"ai-btn",attrs:{"src":_vm.aiAvatar,"alt":""},on:{"click":_vm.jumpToAi}})]),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }